/**
 * Efficiently convert Uint8Array to base64 string
 * Uses chunked approach to avoid stack overflow with large arrays
 *
 * @param data - Uint8Array to convert
 * @returns Base64 encoded string
 */
export function uint8ArrayToBase64(data: Uint8Array): string {
  // Process in chunks to avoid stack overflow
  const chunkSize = 8192;
  let result = "";

  for (let i = 0; i < data.length; i += chunkSize) {
    const chunk = data.slice(i, i + chunkSize);
    // Convert chunk to string using apply to avoid spread operator issues
    const chunkString = String.fromCharCode.apply(null, Array.from(chunk));
    result += btoa(chunkString);
  }

  return result;
}

/**
 * Convert string to base64 (for consistency)
 * @param data - String to convert
 * @returns Base64 encoded string
 */
export function stringToBase64(data: string): string {
  // For strings, btoa is the standard API and works fine
  // But we convert to Uint8Array for consistency
  const encoder = new TextEncoder();
  const uint8Array = encoder.encode(data);
  return uint8ArrayToBase64(uint8Array);
}
